export class MenuOptions {

    constructor(public name: string, public routePath: string) {
        
    }
}
